import { useCallback, useState } from 'react'
import { useMutation } from '@apollo/client/react'
import { AdminAPI } from '@guestgoodie/graphql'

import { PRESETS, resizeImage, uploadToS3 } from '@/features/files'

export default function useUploadAvatar(): [
  (file: File) => Promise<void>,
  boolean
] {
  const [createUploadUrl] = useMutation(AdminAPI.user.GET_AVATAR_UPLOAD_URL)
  const [completeUpload] = useMutation(AdminAPI.user.COMPLETE_AVATAR_UPLOAD)
  const [loading, setLoading] = useState(false)

  const upload = useCallback(
    async (image: File) => {
      setLoading(true)

      try {
        const finalImage = await resizeImage(image, PRESETS.SMALL)
        const { data, error } = await createUploadUrl()

        if (!data) throw error

        const { url } = data.createAvatarUploadUrl

        await uploadToS3(finalImage, url)
        await completeUpload({ refetchQueries: [AdminAPI.user.ME] })
      } finally {
        setLoading(false)
      }
    },
    [createUploadUrl, completeUpload, setLoading]
  )

  return [upload, loading]
}
